/**
 * Documentation navigation configuration
 */

export interface DocsNavItem {
  title: string;
  path: string;
  children?: DocsNavItem[];
}

export const docsNavigation: DocsNavItem[] = [
  {
    title: 'Get Started',
    path: '/docs',
    children: [
      { title: 'Welcome', path: '/docs' },
      { title: 'Quickstart', path: '/docs/quickstart' },
      { title: 'Concepts', path: '/docs/concepts' },
      { title: 'Models', path: '/docs/models' },
    ],
  },
  {
    title: 'Core Features',
    path: '/docs/features',
    children: [
      { title: 'Transcription', path: '/docs/features/transcription' },
      { title: 'AI Summaries', path: '/docs/features/summaries' },
      { title: 'Speaker Detection', path: '/docs/features/speaker-detection' },
      { title: 'Analytics', path: '/docs/features/analytics' },
    ],
  },
  {
    title: 'Integrations',
    path: '/docs/integrations',
    children: [
      { title: 'Zoom', path: '/docs/integrations/zoom' },
      { title: 'Google Meet', path: '/docs/integrations/google-meet' },
      { title: 'Microsoft Teams', path: '/docs/integrations/teams' },
      { title: 'Slack', path: '/docs/integrations/slack' },
    ],
  },
  {
    title: 'API',
    path: '/docs/api',
    children: [
      { title: 'Overview', path: '/docs/api/overview' },
      { title: 'Authentication', path: '/docs/api/authentication' },
      { title: 'Endpoints', path: '/docs/api/endpoints' },
    ],
  },
  {
    title: 'Configuration',
    path: '/docs/configuration',
    children: [
      { title: 'Settings', path: '/docs/configuration/settings' },
    ],
  },
];

